import { apiBaseUrl } from 'app/src/msw/moneytransfer/api/apiBaseurl'
import { transfersCollection } from 'app/src/msw/moneytransfer/initialSeed/transfers'
import type { moneytransferApi } from 'app/src/services/welfareportal'
import { DateTime } from 'luxon'
import { HttpResponse } from 'msw'
import { http } from 'msw/core/http'

export const getTransfers = http.get<object, object, moneytransferApi.TransferPaginated>(
  apiBaseUrl + '/transfers',
  ({ request }) => {
    const url = new URL(request.url)
    const status = url.searchParams.get('status')
    const sort = url.searchParams.get('sort')
    const from = url.searchParams.get('from')
    const to = url.searchParams.get('to')
    const offset = url.searchParams.get('pagingOffset')
    const limit = url.searchParams.get('pagingLimit')
    // const membershipId = url.searchParams.get('membershipId')

    let items = transfersCollection.findMany()

    console.log('MSW: Retrieved transfers: ', items)

    if (sort == '+date') {
      items = items.sort((a, b) => DateTime.fromISO(a.date).toMillis() - DateTime.fromISO(b.date).toMillis())
    }

    if (sort == '-date') {
      items = items.sort((a, b) => DateTime.fromISO(b.date).toMillis() - DateTime.fromISO(a.date).toMillis())
    }
    if (status !== null) {
      items = items.filter((item) => status?.split(',').includes(item?.status?.value))
    }

    let fromDate = undefined
    let toDate = undefined
    if (from !== null) {
      fromDate = DateTime.fromISO(from).toMillis()
    }
    if (to !== null) {
      toDate = DateTime.fromISO(to).toMillis()
    }

    items = items?.filter((item) => {
      const orderDate = DateTime.fromISO(item.date)

      if (fromDate && toDate) {
        return orderDate.toMillis() >= fromDate && orderDate.toMillis() <= toDate
      } else if (fromDate) {
        return orderDate.toMillis() >= fromDate
      } else if (toDate) {
        return orderDate.toMillis() <= toDate
      } else {
        return true
      }
    })

    const totItems = items.length

    const offsetInt = offset !== null ? parseInt(offset, 10) : 0
    const limitInt = limit !== null ? parseInt(limit, 10) : 5

    items = items.slice(offsetInt, offsetInt + limitInt)

    const transferListResponse: moneytransferApi.TransferPaginated = {
      items: items,
      paging: {
        limit: limitInt,
        offset: offsetInt,
        total: totItems,
      },
    }

    console.log('MSW: Returning transfer list response: ', transferListResponse)

    return HttpResponse.json(transferListResponse)
  },
)
